import useUpdateSettings from 'components/UI/Filter/hooks/useUpdateSettings'
import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { MFilters } from 'types/filterTypes'

export type OptionsToSaveType = MFilters.FilterTypes[MFilters.FilterKey] | Record<string, never>

const useSynchronisePunchFilters = (contentName: MFilters.ContentTypes) => {
  const { saveOptions: saveOptionsPunchValidation } = useUpdateSettings('punchValidation')
  const { saveOptions: saveOptionsPunchCardlist } = useUpdateSettings('punchCards')

  const savedOptionsPunchCard = useSelector((state: MStore.RootState) => state.settings[`filter-punchCards`])
  const savedOptionsPunchValidation = useSelector((state: MStore.RootState) => state.settings[`filter-punchValidation`])

  useEffect(() => {
    if (contentName === 'punchCards' && savedOptionsPunchCard) {
      saveOptionsPunchValidation({ ...savedOptionsPunchCard })
    }
  }, [contentName, saveOptionsPunchValidation, savedOptionsPunchCard])

  useEffect(() => {
    if (contentName === 'punchValidation' && savedOptionsPunchValidation) {
      saveOptionsPunchCardlist({ ...savedOptionsPunchValidation })
    }
  }, [contentName, saveOptionsPunchCardlist, savedOptionsPunchValidation])
}

export default useSynchronisePunchFilters
